
// // src/hooks/useQR.js
// export function makeToken(prefix = 'VT') {
//     const rnd = Math.random().toString(36).slice(2, 10);
//     return `${prefix}-${Date.now()}-${rnd}`;
// }


// src/hooks/useQR.js
export function makeToken(prefix = 'VT') {
    const rnd = Math.random().toString(36).slice(2, 10);
    return `${prefix}-${Date.now()}-${rnd}`;
}
